import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-accShutDown",
  "use": "icon-accShutDown-usage",
  "viewBox": "0 0 31 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 8\" id=\"icon-accShutDown\">\n  <defs>\n    <style>\n      #icon-accShutDown .cls-1 {\n        fill: #d65849;\n        font-size: 8px;\n        font-family: SourceHanSansCN-Regular, Source Han Sans CN;\n      }\n    </style>\n  </defs>\n  <text id=\"icon-accShutDown_ACC关闭\" class=\"cls-1\" transform=\"translate(0 7)\"><tspan x=\"0\" y=\"0\">ACC关闭</tspan></text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol